import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withKeys as _withKeys, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = {
  key: 0,
  style: {"color":"#e04055","text-align":"center"},
  class: "ion-padding"
}
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { style: {"color":"#18c75d","text-align":"center"} }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = { key: 2 }
const _hoisted_8 = {
  key: 0,
  class: "error ion-padding",
  id: "password-guidelines-hover"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "basic-login-text" }, "Passwort zurücksetzen", -1)
const _hoisted_10 = {
  style: {"color":"#e04055","text-align":"center"},
  class: "ion-padding-top"
}
const _hoisted_11 = { style: {"color":"var(--ion-color-dark)"} }
const _hoisted_12 = {
  key: 3,
  style: {"text-align":"center"},
  class: "ion-padding"
}
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("a", { class: "link-text-color" }, " Login", -1)
const _hoisted_15 = { style: {"margin":"auto","text-align":"center"} }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("a", {
  style: {"cursor":"pointer"},
  class: "ion-color-medium"
}, "Datenschutz", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { style: {"padding-left":"5px","padding-right":"5px"} }, "|", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("a", { style: {"cursor":"pointer"} }, "AGB", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { style: {"padding-left":"5px","padding-right":"5px"} }, "|", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("a", { style: {"cursor":"pointer"} }, "Impressum", -1)
const _hoisted_21 = { style: {"margin":"auto","text-align":"center","padding-bottom":"15px","font-size":"7px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_verify_success_animation = _resolveComponent("verify-success-animation")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_login_success_animation = _resolveComponent("login-success-animation")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_mobility_logo = _resolveComponent("mobility-logo")!
  const _component_ion_footer = _resolveComponent("ion-footer")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, { class: "ion-padding" }, {
        default: _withCtx(() => [
          ($setup.hasPasswordChangedSuccessfuly)
            ? (_openBlock(), _createElementBlock("h1", {
                key: 0,
                class: "loginHeader",
                innerHTML: $setup.passwordChanged
              }, null, 8, _hoisted_1))
            : (_openBlock(), _createElementBlock("h1", {
                key: 1,
                class: "loginHeader",
                innerHTML: $setup.passwordVerify
              }, null, 8, _hoisted_2))
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, { class: "ion-padding" }, {
        default: _withCtx(() => [
          _createElementVNode("div", null, [
            ($setup.verifyError)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createElementVNode("p", null, _toDisplayString($setup.verifyError), 1)
                ]))
              : _createCommentVNode("", true),
            ($setup.hasPasswordChangedSuccessfuly)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createVNode(_component_verify_success_animation, { style: {"max-height":"30rem","width":"100%","margin-bottom":"-1em","margin-top":"-1em"} }),
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("p", null, [
                      _createTextVNode(_toDisplayString($setup.setNewPasswordSuccessText), 1),
                      _hoisted_6,
                      _createTextVNode(_toDisplayString($setup.setNewPasswordSucessGoBackToAppInfo), 1)
                    ])
                  ])
                ]))
              : (!$setup.hasPasswordChangedSuccessfuly && !$setup.newResendLinkSend)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createElementVNode("form", {
                      onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => ($setup.sendNewPassword && $setup.sendNewPassword(...args)), ["prevent"]))
                    }, [
                      _createVNode(_component_ion_card, { class: "ion-no-padding ion-no-margin" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, { position: "stacked" }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Passwort")
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_input, {
                                modelValue: $setup.passwordFormData.password,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.passwordFormData.password) = $event)),
                                placeholder: "Neues Passwort",
                                type: "password",
                                required: "true",
                                tabindex: "3"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, { position: "stacked" }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Passwort bestätigen")
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_input, {
                                modelValue: $setup.passwordFormData.passwordConfirm,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.passwordFormData.passwordConfirm) = $event)),
                                placeholder: "Neues Passwort bestätigen",
                                type: "password",
                                required: "true",
                                tabindex: "4",
                                onKeyup: _withKeys($setup.sendNewPassword, ["enter"])
                              }, null, 8, ["modelValue", "onKeyup"])
                            ]),
                            _: 1
                          }),
                          ($setup.passwordError)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_8, [
                                _createTextVNode(_toDisplayString($setup.passwordError) + " ", 1),
                                _createElementVNode("button", {
                                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($setup.handlePasswordHover && $setup.handlePasswordHover(...args)))
                                }, "ℹ️")
                              ]))
                            : _createCommentVNode("", true),
                          _createVNode(_component_ion_button, {
                            class: "basic-login-btn",
                            expand: "block",
                            type: "submit",
                            style: {"min-height":"65px","margin-bottom":"-5px","margin-top":"20px"}
                          }, {
                            default: _withCtx(() => [
                              _hoisted_9
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ], 32),
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("p", _hoisted_11, _toDisplayString($setup.resendPasswordTitle), 1),
                      _createVNode(_component_ion_button, {
                        color: "danger",
                        expand: "block",
                        onClick: $setup.resendLink
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString($setup.verifyErrorResendLink) + " ", 1),
                          _createVNode(_component_ion_icon, {
                            class: "ion-padding-start",
                            icon: $setup.icons.mailOutline
                          }, null, 8, ["icon"])
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ])
                  ]))
                : ($setup.newResendLinkSend)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      _createVNode(_component_login_success_animation, { style: {"max-height":"30rem","width":"100%","margin-bottom":"-1em","margin-top":"-1em"} }),
                      _createElementVNode("p", { innerHTML: $setup.setNewPasswordSuccessBody }, null, 8, _hoisted_13),
                      _createElementVNode("p", null, [
                        _createTextVNode(_toDisplayString($setup.setNewPasswordGoBackTo) + " ", 1),
                        _createVNode(_component_router_link, { to: "/login" }, {
                          default: _withCtx(() => [
                            _hoisted_14
                          ]),
                          _: 1
                        })
                      ])
                    ]))
                  : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }),
      (!$setup.hasPasswordChangedSuccessfuly && !$setup.newResendLinkSend)
        ? (_openBlock(), _createBlock(_component_ion_footer, {
            key: 0,
            style: {"padding":"25px"}
          }, {
            default: _withCtx(() => [
              _createElementVNode("p", _hoisted_15, [
                _createElementVNode("span", null, [
                  _createVNode(_component_router_link, { to: "/privacy-crudafoch" }, {
                    default: _withCtx(() => [
                      _hoisted_16
                    ]),
                    _: 1
                  })
                ]),
                _hoisted_17,
                _createElementVNode("span", null, [
                  _createVNode(_component_router_link, { to: "/terms" }, {
                    default: _withCtx(() => [
                      _hoisted_18
                    ]),
                    _: 1
                  })
                ]),
                _hoisted_19,
                _createElementVNode("span", null, [
                  _createVNode(_component_router_link, { to: "/impress" }, {
                    default: _withCtx(() => [
                      _hoisted_20
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("p", _hoisted_21, " Version: " + _toDisplayString($setup.appVersion), 1),
              _createVNode(_component_mobility_logo)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}